import { render, staticRenderFns } from "./albums.vue?vue&type=template&id=43225981&scoped=true"
import script from "./albums.vue?vue&type=script&lang=js"
export * from "./albums.vue?vue&type=script&lang=js"
import style0 from "./albums.vue?vue&type=style&index=0&id=43225981&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_4rliqqz3ui7xo7iaw2ukiguuga/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43225981",
  null
  
)

export default component.exports